import * as React from "react"
import { ErrorPage, type ErrorPageProps } from "./ErrorPage"

export interface Error500Props extends Partial<Omit<ErrorPageProps, "code">> {
  /**
   * Custom illustration for the 500 page
   */
  illustration?: React.ReactNode
}

function Error500({
  title = "Server Error",
  description = "Oops! Something went wrong on our end. Please try again later or contact support if the problem persists.",
  illustration,
  ...props
}: Error500Props) {
  return (
    <ErrorPage
      code="500"
      title={title}
      description={description}
      illustration={illustration}
      {...props}
    />
  )
}

Error500.displayName = "Error500"

export { Error500 }
